import { Stack } from '@mui/material';
import { Loading } from 'framework/ui/mui-builder';
import { FilterBar, FilterBarProps } from './components/FilterBar';
import PageHeader from './components/PageHeader/PageHeader';
import ViewSlots from './components/ViewSlots/ViewSlots';
import type { PageContentLayout, PageDrawer } from './types';

export interface AddressableViewLayoutProps {
  title?: string;
  breadcrumbsCurrentPage?: string;
  showBreadcrumbs?: boolean;
  headerMetadata?: string;
  loading?: boolean;
  filterBarProps?: FilterBarProps;
  contentLayout?: PageContentLayout;
  drawer?: PageDrawer | PageDrawer[];
}

const AddressableViewLayout: React.FC<AddressableViewLayoutProps> = ({
  title,
  breadcrumbsCurrentPage,
  showBreadcrumbs = false,
  headerMetadata,
  loading,
  filterBarProps,
  contentLayout,
  drawer,
}) => {
  if (loading && !contentLayout) {
    return <Loading />;
  }

  return (
    <Stack
      direction="column"
      gap={1}
      sx={{
        height: 'calc(100vh - 132px)',
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <PageHeader
        title={title}
        breadcrumbsCurrentPage={breadcrumbsCurrentPage}
        showBreadcrumbs={showBreadcrumbs}
        metadata={headerMetadata}
      />
      <ViewSlots
        filterBar={filterBarProps && <FilterBar {...filterBarProps} />}
        contentLayout={contentLayout}
        loading={loading}
      />
      {drawer}
    </Stack>
  );
};

export default AddressableViewLayout;
